import React from 'react'
import { Observable } from 'rx'
import {
  ConfirmBetslipBetsSucceeded,
  ConfirmBetSucceeded,
  ConfirmMultiBetSucceeded,
} from '@core/Areas/Quickbet/signals'
import {
  invalidateKambiPendingTicketsQueryData,
  invalidateRacingPendingTicketsQueryData,
} from '@core/Data/Account/PendingTicketsCount/helpers/invalidation'
import { startListening } from '@core/Store/listenerMiddleware'
import { confirmAllBets } from '@mobi/betslip/Store/Workflow/asyncActions'
import { updateUserData } from '@core/Areas/Kambi/Store'

export const useInvalidatePendingCountOnEvents = () => {
  // Invalidate on bet placement w/ Quickbet and legacy BetSlip
  React.useEffect(() => {
    const subscription = Observable.merge(
      ConfirmBetSucceeded.signal$,
      ConfirmBetslipBetsSucceeded.signal$,
      ConfirmMultiBetSucceeded.signal$
    )
      .debounce(500)
      .subscribe(invalidateRacingPendingTicketsQueryData)
    return () => subscription.dispose()
  }, [])

  // Invalidate on bet placement w/ new BetSlip
  React.useEffect(() => {
    const dispose = startListening({
      actionCreator: confirmAllBets.fulfilled,
      effect: invalidateRacingPendingTicketsQueryData,
    })
    return () => dispose()
  }, [])

  // Ensure kambi ticket count is correct by forcing update on session id
  React.useEffect(() => {
    const dispose = startListening({
      actionCreator: updateUserData,
      effect: invalidateKambiPendingTicketsQueryData,
    })
    return () => dispose()
  }, [])
}
